// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__MIHhH","consentsList":"PatientConsents_consentsList__2DKAQ","consentsListEmpty":"PatientConsents_consentsListEmpty__1cgxE"};